module.exports = __webpack_public_path__ + "static/media/css.0ddd3aa4.svg";